(($, Drupal) => {
  const initToggleList = (el) => {
    const readMoreButton = $(el).find('button[data-action=show-more]');
    const readLessButton = $(el).find('button[data-action=show-less]');
    const hiddenListRest = $(el).find('.toggle-list__rest');
    const hiddenFlex = hiddenListRest.hasClass('grid');
    let elPosition;

    const height = $(hiddenListRest).height();

    const duration = 200;

    const iterations = 50;

    const timeout = duration / iterations;

    const deltaHeight = height / iterations;

    // call function, callback with timeout, it helps to make slide effect slower and visible

    const loop = (conditionFn, postFn, fn, done) => {
      const next = () => {
        setTimeout(iteration, timeout);
      };
      const iteration = () => {
        if (conditionFn()) {
          fn();
          next();
          postFn();
        } else {
          done && done();
        }
      };
      iteration();
    };

    const slideDown = (height) => {
      elPosition = $(el).position().top;
      let h = 0;
      $(hiddenListRest).css({ display: hiddenFlex ? 'flex' : ' block', overflow: 'hidden' });
      $(readMoreButton).css({ display: 'none' });

      loop(
        () => h < height,
        () => {
          h += deltaHeight;
        },
        () => {
          $(hiddenListRest).css('height', h);
        },
        () => {
          $(hiddenListRest).css('height', '');
          if (readLessButton.length > 0) {
            $(readLessButton).css({ display: 'flex' }).removeClass('active');
          }
        },
      );
    };

    const slideUp = (height) => {
      let h = height;
      $(hiddenListRest).css({ overflow: 'hidden' });

      loop(
        () => h > 0,
        () => {
          h -= deltaHeight;
        },
        () => {
          $(hiddenListRest).css('height', h);
        },
        () => {
          $(document).scrollTop(elPosition);

          $(hiddenListRest).css({ display: 'none', height: '' });
          if (readLessButton.length > 0) {
            $(readMoreButton).css({ display: 'flex' }).removeClass('active');
            $(readLessButton).css({ display: 'none' });
          }
        },
      );
    };

    $(readMoreButton).on('click', (e) => {
      e.preventDefault();

      slideDown(height);
    });

    $(readLessButton).on('click', (e) => {
      e.preventDefault();

      slideUp(height);
    });
  };

  Drupal.behaviors.mstToggleList = {
    attach: (context) => {
      $('.toggle-list', context).each((index, element) => initToggleList(element));
    },
  };
})(jQuery, Drupal);
